// Composant Card - Affiche une carte avec image, titre, description et boutons d'action

import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "../ui/icons/ArrowRightIcon";

const Card = ({ image, title, description, link, tags, doc, type, language = 'fr', index }) => {
  // Définit la couleur des tags selon leur catégorie
  const colormap = {
    dashboard: "bg-orange-100 text-orange-800",
    api: "bg-blue-100 text-blue-800",
    application: "bg-red-100 text-red-800",
    website: "bg-violet-100 text-violet-800",
  };
  const isIndicateur = type === "indicateur";
  const labels = {
    fr: {
      app: "Vers l'app",
      indicateur: "Vers l'indicateur",
      doc: "Vers la doc",
    },
    de: {
      app: "Zur App",
      indicateur: "Zum Indikator",
      doc: "Zur Dokumentation",
    },
  };

  const mainButtonLabel = isIndicateur ? labels[language]?.indicateur || labels.fr.indicateur : labels[language]?.app || labels.fr.app;
  const docButtonLabel = labels[language]?.doc || labels.fr.doc;
  const mainButtonHref = isIndicateur ? `/indicateur/${doc}` : link;

  return (
    // IMAGE

    <div
      className="flex flex-col justify-between rounded shadow-lg bg-white bg-opacity-70"
      key={index}
    >
      {/* Affiche les tags avec couleurs */}
      <div class="flex flex-row justify-center ">
        {tags?.map((tag) => {
          const color = colormap[tag] || "gray";
          return (
            <span
              className={`${color} text-sm font-small mr-2 my-3 px-2.5 py-0.5 rounded`}
            >
              {tag}
            </span>
          );
        })}
      </div>
      {/* Image de la carte */}
      <img class="mx-auto w-5/6 pt-2" src={image} alt="logo"></img>

      {/* Titre et description */}
      <div className="flex-grow px-6 py-2">
        <div className="font-bold text-xl mb-2 text-center">{title}</div>
        <p className="text-gray-800 text-base">{description}</p>
      </div>
      <div className="pb-3">
        {/* Boutons d'action: lien vers l'app/indicateur et accès à la documentation */}

        <div className="flex flex-row justify-center">
          {isIndicateur ? (
            <Link
              className="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-500 rounded-lg hover:bg-blue-700"
              key={doc}
              to={mainButtonHref}
            >
              {mainButtonLabel}
              <ArrowRightIcon />
            </Link>
          ) : (
            <a
              href={mainButtonHref}
              className="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-500 rounded-lg hover:bg-blue-700"
              target="_blank"
              rel="noopener noreferrer"
            >
              {mainButtonLabel}
              <ArrowRightIcon />
            </a>
          )}

          {!isIndicateur && doc && (
            <Link
              className="inline-flex items-center ml-2 px-3 py-2 text-sm font-medium text-center text-white bg-slate-400 rounded-lg hover:bg-slate-500"
              key={doc}
              to={`/doc/${doc}`}
            >
              {docButtonLabel}
              <ArrowRightIcon />
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default Card;
